"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["DATE"] = "date";
    InputType["DATE_TIME_LOCAL"] = "datetime-local";
    InputType["COLOR"] = "color";
    InputType["EMAIL"] = "email";
    InputType["HIDDEN"] = "hidden";
    InputType["MONTH"] = "month";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
})(InputType || (exports.InputType = InputType = {}));
